export var QUERY_TASK_TAB_ID = 'tab';
export var QUERY_TASK_SECTION_ID = 'section';
export var QUERY_SERVICE_PROVIDER = 'service-provider';
export var QUERY_CALENDAR_AUTH_ERROR = 'calendar-auth-error';
export var QUERY_ADD_CALENDAR = 'add-calendar';
export var QUERY_IS_EMBEDDED = 'is-embedded';
export var QUERY_ONBOARDING_TASK_ID = 'onboarding-task-id';
export var QUERY_ENABLE_SESSION_EXPIRATION = 'enable-session-expiration';
export var QUERY_SEARCH_TERM = 'searchTerm';
export var QUERY_PAGINATION_TOKEN = 'paginationToken';
export var QUERY_CATEGORY_ID = 'categoryId';
export var QUERY_TASK_ID = 'taskId';
export var QUERY_TEMPLATE_ID = 'templateId';
export var QUERY_PROPOSAL_ID = 'proposalId';
export var QUERY_ERROR = 'error';